module.exports = __webpack_public_path__ + "img/about-main-2-mob.159fd738.webp";